module.exports = __webpack_public_path__ + "static/media/notificationicon.a93ce9ac.svg";